export const menuData = [
  { title: "Home", icon: "/images/icons/home_.svg", link: "/" },
  {
    title: "Publications",
    icon: "/images/icons/paper.svg", 
    link: "#here",
  },
  { title: "Photo Gallery", icon: "/images/icons/photos.svg", link: "https://www.instagram.com/steve.wong.v/" },
]

export const tooltipData = [
  { title: "Home", icon: "/images/icons/home_.svg", link: "#home" },
  { title: "Publications", icon: "/images/icons/paper.svg", link: "#public" },
  { title: "Photo Gallery", icon: "/images/icons/photos.svg", link: "https://www.instagram.com/steve.wong.v/" },
]
